import { render, staticRenderFns } from "./PrivacyPolicyProvider.vue?vue&type=template&id=6c7fe627"
import script from "./PrivacyPolicyProvider.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports